import React, { FC, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { InputText, InputTextArea } from '../../../components/input'
import { IInputArrayFormProps, IInputArrayDataStructureItem } from '../../../components/input/arrayData'
import { UserSelect } from '../../../components/input/select/UserSelect'
import { Button } from '../../../modules/button'
import { InputWraper, useForm } from '../../../modules/form'
import { ObjectUtils } from '../../../modules/utils'

export const ItCodeContentStructure: IInputArrayDataStructureItem[] = [
  {
    name: 'staff',
    label: 'Người sử dụng',
    isVisibleOnList: true,
  },
  {
    name: 'staffCode',
    label: 'Mã nhân viên',
    isVisibleOnList: true,
  },
  {
    name: 'content',
    label: 'Nội dung yêu cầu',
    isVisibleOnList: true,
  },
]

export const ItCodeContentForm: FC<IInputArrayFormProps> = (props) => {
  const { childFormData } = props;
  const employees = useSelector((state: any) => state.employee.employees);
  const [employeesSelected, setEmployeesSelected] = useState<any>(null);
  const [employeesCode, setEmployeesCode] = useState((childFormData && childFormData.staffCode) || '');

  const { handleSubmit, getInputProps, setValues } = useForm({
    structure: props.structure.map((item => {
      return {
        ...item,
        defaultValue: ObjectUtils.getIn(childFormData, item.name) || item.defaultValue
      }
    })),
    onSubmit: (values) => {
      if (!values.staffCode && !values.staff) {
        const employee: any = employees.find((v: any) => v.eMail === employeesSelected);
        values.staffCode = employeesCode;
        values.staff = employee.Title;
      }
      props.onSubmit(values)
    },
  })

  const onEmployeeChange = (selectedOptions: any) => {
    const employee: any = employees.find((v: any) => v.eEmployeeId === selectedOptions.value);
    setEmployeesSelected(selectedOptions);
    setEmployeesCode(employee.eEmployeeId);
    setValues({ staff: selectedOptions.label, staffCode: employee.eEmployeeId });
  }

  useEffect(() => {
    if (employees) {
      if (childFormData && childFormData.staffCode) {
        setEmployeesSelected(employees.find((o: any) => o.eEmployeeId === childFormData.staffCode).eMail);
      } else {
        setEmployeesSelected(employees[0].eMail);
        setEmployeesCode(employees[0].eEmployeeId);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employees])

  return (
    <div className="ItCodeContentForm py-4">
      <InputWraper inputProps={getInputProps('staff')} renderInput={s => <UserSelect
        {...s}
        options={(employees.length > 0 && employees.map((o: any) => ({ label: o.Title, value: o.eEmployeeId }))) || []}
        placeholder="Chọn người sử dụng"
        onChange={onEmployeeChange}
        value={employeesSelected?.value}
      />} />
      <InputWraper inputProps={getInputProps('staffCode')} renderInput={s => <InputText
        {...s}
        value={employeesCode}
        isDisabled={true}
      />} />
      <InputWraper inputProps={getInputProps('content')} component={InputTextArea} />

      <div className="foot">
        <Button
          type="button"
          label="Xác nhận"
          onClick={handleSubmit}
        />
      </div>
    </div>
  )
}